import SignInCardCommon, { SignInCardCommonProps } from "../SignInCardCommon";

type Props = SignInCardCommonProps;

export default function SignInCardStudentJoinClass(props: Props) {
  return (
    <SignInCardCommon
      headerMessage={`${props.action} to join the class`}
      {...props}
    />
  );
}
